import { storedHtmlDomPurifyConfig } from '@lmc/ui-kit/src/constants/storedHtmlDomPurifyConfig'
import DOMPurify from 'dompurify'

/**
 * Sanitizes HTML the same way as {@link ViewStoredHtml} before injection.
 */
export function sanitizeStoredHtml(html: unknown): string {
  return DOMPurify.sanitize(
    html === undefined || html === null ? '' : String(html),
    storedHtmlDomPurifyConfig
  )
}

/**
 * True when stored HTML will show meaningful text after the same DOMPurify pass
 * used for rendering (avoids mismatches where regex sees text inside disallowed tags).
 */
export function hasMeaningfulStoredHtml(html: unknown): boolean {
  const textOnly = sanitizeStoredHtml(html)
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;|&#160;|\xA0/gi, ' ')
    .trim()
  return textOnly.length > 0
}
